module.exports = __webpack_public_path__ + "static/media/Pixelate.0098dc76.jpg";